module.exports = __webpack_public_path__ + "static/media/thumb-up.2b38ae24.png";